export var getStyles = function () {
    return {
        outerWrapper: {}
    };
};
//# sourceMappingURL=Wizard.styles.js.map